module.exports = __webpack_public_path__ + "static/media/paragon_rnd_building.22120132.jpg";